var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChiusinoGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#52A83E;stroke:#1D1D1B;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,1.8c2.3-0.5,4.8-0.3,6.9,0.7c2,0.9,3.6,2.5,4.7,4.4c1.1,1.9,1.6,4.1,1.3,6.2c-0.3,1.9-1.1,3.6-2.1,5.1 c-0.9,1.4-2,2.6-3,3.9c-1.8,2.1-3.6,4.3-5.4,6.4c-2.1-2.2-4.1-4.5-6.1-6.8c-1.3-1.5-2.6-3.2-3.5-5c-0.9-1.9-1.2-4-0.9-6.1 c0.3-2.2,1.3-4.2,2.8-5.8C8.8,3.3,10.6,2.2,12.6,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.5,7.1c-1.6,0.1-3,1-3.9,2.4c-0.7,1-1,2.3-0.8,3.6c0.2,1.3,0.9,2.5,1.9,3.3c0.8,0.7,1.9,1.1,2.9,1.1 c1,0.1,2.1-0.2,3-0.7c0.8-0.5,1.5-1.2,1.9-2.1c0.6-1.2,0.7-2.5,0.4-3.8c-0.4-1.3-1.2-2.4-2.4-3.1C16.7,7.3,15.6,7,14.5,7.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChiusinoGreen);
export default __webpack_public_path__ + "static/media/chiusino_green.87f7721a039b87218fe40764bf68bad3.svg";
export { ForwardRef as ReactComponent };